/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useIntl } from "gatsby-plugin-intl"

function Seo({ title,keywords,description,meta }) {
   
  const allSiteMetadata = {
    en: {
      title: "Fantuan for Merchants | Become a Fantuan partner, grow your business. ",
      keywords:
      "delivery, food, food delivery, chinese food, korean food, japanese food, asian food, bubble tea, dessert, restaurant, order, online order, dinner, promotion, restaurant near me",
      description:
      "Expand your business and grow your sales with Fantuan. List your business on the Fantuan App and start reaching out to new customers.",
    },
    zh: {
      title: "成为饭团合作商家 | 饭团外卖",
      keywords: "外卖送餐，中餐美食，餐厅自取，跑腿代购，生活服务，优惠，奶茶，甜品，韩餐，日料，寿司，炸鸡，川菜，粤菜，早茶",
      description:
      "加入饭团商家行列，助力业务成长。上线饭团外卖，提升线上曝光度，接触更多本地新客户。",
    },
    fr: {
      title: "Fantuan pour les marchands | Devenez un partenaire Fantuan, développez votre entreprise. ",
      keywords:
      "livraison, aliments, livraison de nourriture, nourriture chinoise, nourriture coréenne, nourriture japonaise, nourriture asiatique, thé à bulles, dessert, restaurant, commande, commande en ligne, dîner, promotion, restaurant près de moi",
      description:
      "Développez votre entreprise et augmentez vos ventes avec Fantuan. Inscrivez votre entreprise sur l'application Fantuan et commencez à toucher de nouveaux clients.",
    },
  }
  const intl = useIntl()
  const lang = intl.locale
  const siteMetadata=allSiteMetadata[lang]
  const defaultTitle = siteMetadata.title
  const metaKeywords=keywords||siteMetadata.keywords
  const metaDescription = description || siteMetadata.description
 


  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title ? `${title} | ${defaultTitle}` : defaultTitle}
    //   titleTemplate={title ? `%s | ${defaultTitle}` : defaultTitle}
      link={[
        {
            rel:"shortcut icon",
            href:"/favicon.png"
        }
      ]}
      meta={[
        {
          name:'keywords',
          content:metaKeywords,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: 'viewport',
          content: 'width=1440,initial-scale=1.0,user-scalbale=yes'
        }
      ].concat(meta||[])}
    />
  )
}

Seo.propTypes = {
  title: PropTypes.string,
  keywords:PropTypes.string,
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
}

export default Seo
